import { NavLink, Outlet, Link } from "react-router-dom";
import { LOGO_URL } from "../../components/Logo";
import { useLang } from "../../context/LangContext";
import {
  Map as MapIcon,
  MessagesSquare,
  BarChart3,
  Navigation,
  User,
  ArrowLeft,
} from "lucide-react";

export default function AppLayout() {
  const { t } = useLang();
  const tabs = [
    { to: "/app", end: true, icon: MapIcon, label: t("app.tab_map"), id: "map" },
    { to: "/app/chat", icon: MessagesSquare, label: t("app.tab_chat"), id: "chat" },
    {
      to: "/app/dashboard",
      icon: BarChart3,
      label: t("app.tab_progress"),
      id: "dashboard",
    },
    { to: "/app/route", icon: Navigation, label: t("app.tab_route"), id: "route" },
    { to: "/app/profile", icon: User, label: t("app.tab_profile"), id: "profile" },
  ];

  return (
    <div
      className="min-h-screen flex flex-col bg-[#0A0A0A] text-white"
      data-testid="app-layout"
    >
      <header className="sticky top-0 z-40 bg-[#0A0A0A] border-b border-white/[0.08]">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link
            to="/"
            data-testid="app-back-home-link"
            className="text-white/60 hover:text-white flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            {t("app.back")}
          </Link>
          <div className="flex items-center gap-2">
            <img
              src={LOGO_URL}
              alt="HolyLand Award"
              className="h-7 w-7 rounded-lg object-cover"
              style={{ filter: "brightness(1.15) saturate(1.05)" }}
            />
            <span className="font-display font-semibold text-[15px]">
              HolyLand <span className="brand-text">Award</span>
            </span>
          </div>
          <div className="w-16" />
        </div>
      </header>

      <main className="flex-1 max-w-2xl w-full mx-auto pb-[68px]">
        <Outlet />
      </main>

      <nav
        data-testid="app-tabbar"
        className="fixed bottom-0 left-0 right-0 z-50 bg-[#0A0A0A] border-t border-white/[0.08]"
        style={{ paddingTop: 4, paddingBottom: 8, height: 68 }}
      >
        <div className="max-w-2xl mx-auto flex h-full">
          {tabs.map((t2) => (
            <NavLink
              key={t2.id}
              to={t2.to}
              end={t2.end}
              data-testid={`tab-${t2.id}-link`}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center justify-center gap-[3px] transition-colors ${
                  isActive ? "text-[#007AFF]" : "text-[#A0AEC0]"
                }`
              }
            >
              <t2.icon strokeWidth={2.25} className="h-[22px] w-[22px]" />
              <span
                className="text-[10px] font-semibold"
                style={{ letterSpacing: "0.3px" }}
              >
                {t2.label}
              </span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
